export default __webpack_public_path__ + "static/media/facebook.3dc01152.svg";